import Proxy from '../Proxy';

class PromocodeSimpleProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('promocodes-simple', parameters);
  }
}

export default PromocodeSimpleProxy;
